import React, { useEffect, useState } from 'react';
import { DateRange, HistoryConfiguration, TrendGranularity } from './AnalyticsModel';
import { UATConstants, formatDate } from 'src/Common/Models/UATConstants';
import { ChoiceGroup, IChoiceGroupOption, IChoiceGroupProps } from '@fluentui/react';
import { Checkbox, DatePicker, Dropdown, IDropdownStyles, IDropdownOption } from '@fluentui/react';
import { SpinButton } from '@fluentui/react';
import { Position } from '@fluentui/react';
import moment from 'moment';
import 'src/styles/Utility.css';
import { InfoIcon } from '../Common/Components/InfoIcon';
import SimpleDropdown from "src/Common/Components/SimpleDropdown";

interface CustomChoiceGroupOption extends IChoiceGroupOption {
  value?: string;
  isChecked?: string;
  onInputChange?: (
    ev?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    option?: CustomChoiceGroupOption
  ) => void;

  onCheckBoxChange?: (
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    option?: { isChecked: boolean } | undefined
  ) => void;
}

interface Props {
  sendBackToParent: Function;
  initialHistoryModel: HistoryConfiguration;
}

const renderField = (
  props: CustomChoiceGroupOption,
  defaultRender: (props: CustomChoiceGroupOption) => JSX.Element
): JSX.Element => {
  return defaultRender(props);
};

export const HistoryTab: React.FunctionComponent<Props> = (props) => {
  //Initialize state from props or default value
  const [historyModel] = useState<HistoryConfiguration>(props.initialHistoryModel);
  let dataRng: DateRange = props.initialHistoryModel.dateRange;

  if (dataRng === null) {
    dataRng = {
      startDate: moment(new Date()).subtract(1, 'months').toDate(),
      endDate: null,
    };
  }
  const [vdateRange, setDateRange] = useState<DateRange>({
    startDate: dataRng.startDate || moment(new Date()).subtract(1, 'months').toDate(),
    endDate: dataRng.endDate || null,
  });

  const initTrendGranularity = props.initialHistoryModel.trendGranularity;
  const [vtrendGranularity, settrendGranularity] = useState<TrendGranularity>({
    granularityType: initTrendGranularity?.granularityType || 0,
    weeklyEndDay: initTrendGranularity?.weeklyEndDay || null,
  });
  const [vrollingDays, setrollingDays] = useState<number>(
    props.initialHistoryModel.rollingDays || 60
  );
  const [vexcludeOldCompletedWorkItems, setexcludeOldCompletedWorkItems] = useState<boolean>(
    props.initialHistoryModel.excludeOldCompletedWorkItems || false
  );
  const [vhistoryType, sethistoryType] = useState<number>(
    props.initialHistoryModel.historyType || 0
  );
  const [vOldCompletedItemsCutoffDate, setOldCompletedItemsCutoffDate] = useState<Date | null>(
    props.initialHistoryModel.oldCompletedItemsCutoffDate || null
  );

  const [isChecked, setisChecked] = useState(true);
  const [isDropchecked, setisDropchecked] = useState(true);
  const [isoption0DivHiddencurrent, setIsoption0DivHiddencurrent] = useState(
    props.initialHistoryModel.historyType !== 0
  );
  const [isoption1DivHidden, setIsoption1DivHidden] = useState(
    props.initialHistoryModel.historyType !== 1
  );
  const [isDivHiddenrange, setIsDivHiddenrange] = useState(
    props.initialHistoryModel.historyType !== 2
  );
  const [isDivHiddenhistory, setIsDivHiddenhistory] = useState(
    props.initialHistoryModel.historyType !== 3
  );
  const [currentOnlyDatePicker, setCurretOnlyDatePicker] = useState(true);
  const [isoptionDaterangedatepicker, setisoptionDaterangedatepicker] = useState(true);
  const [isoptiondaterandedatepickerChkbox, setisoptiondaterandedatepickerChkbox] = useState(false);
  const [isOptiondaterangeDatepickerDispalyChk, setisOptiondaterangeDatepickerDispalyChk] =
    useState(true);

  //Date Fields
  const prevMonthDate: Date = moment(new Date()).subtract(1, 'months').toDate();
  const [optionCurrentDate, setOptionCurrentDate] = useState<Date>(
    props.initialHistoryModel.historyType === 0 ? new Date(dataRng.startDate) : prevMonthDate
  );
  const [optionDateRangeDate, setOptionDateRangeDate] = useState<Date>(
    props.initialHistoryModel.historyType === 2 ? new Date(dataRng.startDate) : prevMonthDate
  );
  const [optionDateRangeEndDate, setOptionDateRangeEndDate] = useState<Date>(
    props.initialHistoryModel.historyType === 2
      ? dataRng.endDate !== null
        ? new Date(dataRng.endDate)
        : prevMonthDate
      : prevMonthDate
  );
  const [optionAllHistoryDate, setOptionAllHistoryDate] = useState<Date>(
    props.initialHistoryModel.historyType === 3 ? new Date(dataRng.startDate) : prevMonthDate
  );

  const [isDivHiddendaily, setIsDivHiddendaily] = useState(true);
  const [isDivHiddenweek, setIsDivHiddenweek] = useState(
    initTrendGranularity?.granularityType !== 1
  );

  useEffect(() => {
    const historyOptions: HistoryConfiguration = {
      ...historyModel,
      historyType: vhistoryType,
      rollingDays: vrollingDays,
      dateRange: {
        startDate: vdateRange?.startDate,
        endDate: vdateRange?.endDate,
      },
      trendGranularity: {
        granularityType: vtrendGranularity?.granularityType,
        weeklyEndDay: vtrendGranularity?.weeklyEndDay,
      },
      excludeOldCompletedWorkItems: vexcludeOldCompletedWorkItems,
      oldCompletedItemsCutoffDate: null,
    };

    switch (vhistoryType) {
      case 0:
        historyOptions.rollingDays = null;
        historyOptions.dateRange = {
          startDate: optionCurrentDate,
          endDate: null,
        };
        historyOptions.trendGranularity = {
          granularityType: null,
          weeklyEndDay: null,
        };
        historyOptions.oldCompletedItemsCutoffDate = vOldCompletedItemsCutoffDate;
        break;
      case 1:
        historyOptions.dateRange = {
          startDate: vdateRange?.startDate,
          endDate: null,
        };
        historyOptions.trendGranularity = {
          granularityType: vtrendGranularity?.granularityType,
          weeklyEndDay: vtrendGranularity?.weeklyEndDay,
        };
        historyOptions.oldCompletedItemsCutoffDate = null;
        break;
      case 2:
        historyOptions.rollingDays = null;
        historyOptions.dateRange = {
          startDate: optionDateRangeDate,
          endDate: isOptiondaterangeDatepickerDispalyChk ? null : optionDateRangeEndDate,
        };
        historyOptions.trendGranularity = {
          granularityType: vtrendGranularity?.granularityType,
          weeklyEndDay: vtrendGranularity?.weeklyEndDay,
        };
        historyOptions.oldCompletedItemsCutoffDate = vexcludeOldCompletedWorkItems
          ? optionDateRangeDate
          : null;
    }
    props.sendBackToParent(historyOptions);
  }, [vdateRange, vrollingDays, vhistoryType, vexcludeOldCompletedWorkItems, vtrendGranularity]);

  function onCheckBoxChange(
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    option?: { isChecked: boolean } | undefined,
    checkboxId?: string
  ): void {
    if (option) {
      option.isChecked = (ev?.currentTarget as HTMLInputElement)?.checked ?? false;
      setexcludeOldCompletedWorkItems(option.isChecked);

      if (option.isChecked) {
        setCurretOnlyDatePicker(false);
        setOldCompletedItemsCutoffDate(vdateRange.startDate);
      } else {
        setCurretOnlyDatePicker(true);
        setOldCompletedItemsCutoffDate(null);
      }
    }
  }

  //date range radio button...
  function onCheckBoxChangeDispaly(
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    option?: { isChecked: boolean } | null
  ): void {
    if (option) {
      setDateRange({
        ...vdateRange,
        endDate: new Date(),
      });

      setisOptiondaterangeDatepickerDispalyChk(option.isChecked);
      option.isChecked = (ev?.currentTarget as HTMLInputElement)?.checked ?? false;
      if (!option.isChecked) {
        setisoptionDaterangedatepicker(false);
        setisoptiondaterandedatepickerChkbox(false);
      } else {
        setisoptionDaterangedatepicker(true);
        setisoptiondaterandedatepickerChkbox(true);
      }
    }
  }

  const dropdownStyles: Partial<IDropdownStyles> = {
    dropdown: {
      textAlign: 'left',
      width: 300,
    },
  };

  const optionstrendGranularity: IDropdownOption[] = [
    { key: '0', text: 'Sunday' },
    { key: '1', text: 'Monday' },
    { key: '2', text: 'Tuesday' },
    { key: '3', text: 'Wednesday' },
    { key: '4', text: 'Thursday' },
    { key: '5', text: 'Friday' },
    { key: '6', text: 'Saturday' },
  ];

  const handleDropdownChange = (
    event: React.FormEvent<HTMLDivElement>,
    option?: IDropdownOption,
    index?: number
  ) => {
    if (option?.key !== undefined) {
      const selectedDay: number = parseInt(option.key.toString());
      settrendGranularity({
        ...vtrendGranularity,
        weeklyEndDay: selectedDay,
      });
    }
  };

  const optionsGranularity: IChoiceGroupOption[] = [
    {
      key: '0',
      text: 'Daily',
    },
    {
      key: '1',
      text: 'Weekly',
      onRenderField: (props, render) => {
        return (
          <div>
            <div>
              <span> {render!(props)} </span>
            </div>
            <div className={` ${isDivHiddenweek ? 'hidden' : ''}`}>
              <SimpleDropdown
                className='history-choicegroup-chktxt-Span'
                tooltipText="History"
                options={optionstrendGranularity}
                styles={dropdownStyles}
                disabled={isDropchecked}
                selectedKey={
                  vtrendGranularity.weeklyEndDay ? vtrendGranularity.weeklyEndDay.toString() : '5'
                }
                onChange={handleDropdownChange}
              />
            </div>
          </div>
        );
      },
    },
    {
      key: '2',
      text: 'Monthly',
    },
  ];

  const options: CustomChoiceGroupOption[] = [
    {
      key: '0',
      text: 'Current Only',
      onRenderField: (props, render) => {
        return (
          <div id='divcurrentonly'>
            <div className='radioBtn-div'>
              <span className='radioBtn-Span'> {render!(props)} </span>
            </div>
            <div className={` ${isoption0DivHiddencurrent ? 'hidden' : ''}`}>
              <DatePicker
                className='history-choicegroup-datepic-Span'
                key={'startdatedatepickercurrent'}
                ariaLabel={UATConstants.PlaceholdersAndTitles.SelectDate}
                disabled={currentOnlyDatePicker}
                formatDate={formatDate}
                value={optionCurrentDate}
                onSelectDate={(date: Date) => {
                  setDateRange({
                    ...vdateRange,
                    startDate: date ? date : new Date(),
                    endDate: null,
                  });
                  setOptionCurrentDate(date);
                  if (vexcludeOldCompletedWorkItems) {
                    setOldCompletedItemsCutoffDate(date || null);
                  }
                }}
              />

              <Checkbox
                className='history-choicegroup-checkbox'
                id='chkboxcurrentOnly'
                label={UATConstants.PlaceholdersAndTitles.ExcludeItemsCompletedBefore}
                checked={vexcludeOldCompletedWorkItems}
                onChange={(ev, checked) =>
                  onCheckBoxChange(ev, {
                    isChecked: checked ?? false,
                  })
                }
              />
            </div>
          </div>
        );
      },
      value: '',
    },
    {
      key: '1',
      text: 'Rolling period in days',
      onRenderField: (props, render) => {
        return (
          <div id='divrollingPeriod'>
            <div className='radioBtn-div'>
              <span> {render!(props)} </span>
            </div>
            <div className={` ${isoption1DivHidden ? 'hidden' : ''}`}>
              <SpinButton
                className='history-choicegroup-chktxt-Span'
                labelPosition={Position.top}
                value={vrollingDays !== undefined ? vrollingDays.toString() : ''}
                min={0}
                max={360}
                step={1}
                incrementButtonAriaLabel={UATConstants.PlaceholdersAndTitles.IncreaseValueByOne}
                decrementButtonAriaLabel={UATConstants.PlaceholdersAndTitles.DecreaseValueByOne}
                onIncrement={() => {
                  const newValue = Number.parseInt(vrollingDays.toString() ?? '0') + 1;
                  setrollingDays(newValue);
                }}
                onDecrement={() => {
                  const newValue = Number.parseInt(vrollingDays.toString() ?? '0') - 1;
                  setrollingDays(newValue);
                }}
              />
              <Checkbox
                className='history-choicegroup-checkbox'
                id='checkboxrolling'
                label={UATConstants.PlaceholdersAndTitles.ExcludeItemsCompletedRollingPreiod}
                checked={vexcludeOldCompletedWorkItems}
                onChange={(ev, checked) =>
                  onCheckBoxChange(ev, { isChecked: checked ?? false }, 'checkboxrolling')
                }
              />
            </div>
          </div>
        );
      },
      value: '',
    },
    {
      key: '2',
      text: 'Date range',
      onRenderField: (props, render) => {
        return (
          <div id='divdateRange'>
            <div>
              <span className='radioBtn-Span'> {render!(props)} </span>
            </div>
            <div className={`div-options-daterange ${isDivHiddenrange ? 'hidden' : ''}`}>
              <DatePicker
                className='history-choicegroup-datepic-Span'
                key={'startdatedatepickerDaterande'}
                ariaLabel={UATConstants.PlaceholdersAndTitles.SelectDate}
                value={optionDateRangeDate}
                onSelectDate={(date: Date) => {
                  setDateRange({
                    ...vdateRange,
                    startDate: date,
                    endDate: null,
                  });
                  setOptionDateRangeDate(date);
                }}
              />

              <Checkbox
                className='history-daterange-checkbox'
                key={'checkbox1daterande'}
                label={UATConstants.PlaceholdersAndTitles.Present}
                checked={isOptiondaterangeDatepickerDispalyChk}
                onChange={(ev, checked) =>
                  onCheckBoxChangeDispaly(ev, {
                    isChecked: checked ?? false,
                  })
                }
              />
              <div
                className={`history-choicegroup-checkbox-dispalydatepicker  ${isoptionDaterangedatepicker ? 'hidden' : ''
                  }`}>
                <label className='bolt-formitem-label'>
                  {UATConstants.PlaceholdersAndTitles.To}
                </label>

                <DatePicker
                  className='history-choicegroup-datepic-Span '
                  key={'enddateDatepickerdaterange'}
                  ariaLabel={UATConstants.PlaceholdersAndTitles.SelectDate}
                  value={optionDateRangeEndDate}
                  onSelectDate={(date: Date) => {
                    setDateRange({
                      ...vdateRange,
                      endDate: date,
                    });
                    setOptionDateRangeEndDate(date);
                  }}
                />
              </div>

              <Checkbox
                className='history-choicegroup-checkbox-daterange'
                key={'checkbox2daterange'}
                label={UATConstants.PlaceholdersAndTitles.ExcludeItemsCompletedStartDate}
                checked={vexcludeOldCompletedWorkItems}
                onChange={(ev, checked) =>
                  onCheckBoxChange(ev, {
                    isChecked: checked ?? false,
                  })
                }
              />
            </div>
          </div>
        );
      },
      value: '',
    },
    {
      key: '3',
      text: 'All history',
      onRenderField: (props, render) => {
        return (
          <div id='divallHistory'>
            <div>
              <span className='radioBtn-Span'> {render!(props)} </span>
            </div>
            <div className={`${isDivHiddenhistory ? 'hidden' : ''}`}>
              <DatePicker
                className='history-choicegroup-datepic-Span'
                ariaLabel={UATConstants.PlaceholdersAndTitles.SelectDate}
                disabled={currentOnlyDatePicker}
                value={optionAllHistoryDate}
                onSelectDate={(date: Date) => {
                  setDateRange({
                    ...vdateRange,
                    startDate: date,
                    endDate: null,
                  });
                  setOptionAllHistoryDate(date);
                }}
              />
              <Checkbox
                className='history-choicegroup-checkbox'
                label={UATConstants.PlaceholdersAndTitles.ExcludeItemsCompletedBefore}
                checked={vexcludeOldCompletedWorkItems}
                onChange={(ev, checked) =>
                  onCheckBoxChange(ev, {
                    isChecked: checked ?? false,
                  })
                }
              />
            </div>
          </div>
        );
      },
      value: '',
      disabled: true,
    },
  ];

  function handleChange(
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    option?: IChoiceGroupOption
  ): void {
    if (option) {
      switch (option.key) {
        case '0':
          setIsoption0DivHiddencurrent(false);
          setIsoption1DivHidden(true);
          setIsDivHiddenrange(true);
          setIsDivHiddenhistory(true);
          setisChecked(true); //Granulity radio buttons disable.
          setisDropchecked(true);
          setisoptionDaterangedatepicker(false);
          sethistoryType(parseInt(option.key));
          settrendGranularity({
            ...vtrendGranularity,
            granularityType: null,
            weeklyEndDay: null,
          });
          break;
        case '1':
          setIsoption1DivHidden(false);
          setIsoption0DivHiddencurrent(true);
          setIsDivHiddenrange(true);
          setIsDivHiddenhistory(true);
          setisChecked(false);
          setisDropchecked(false);
          sethistoryType(parseInt(option.key));
          settrendGranularity({
            ...vtrendGranularity,
            granularityType: 0,
            weeklyEndDay: 5,
          });
          break;

        case '2':
          setIsoption1DivHidden(true);
          setIsoption0DivHiddencurrent(true);
          setIsDivHiddenrange(false);
          setIsDivHiddenhistory(true);
          setisChecked(false);
          setisDropchecked(false);
          setisoptionDaterangedatepicker(isOptiondaterangeDatepickerDispalyChk);
          sethistoryType(parseInt(option.key));
          settrendGranularity({
            ...vtrendGranularity,
            granularityType: 0,
            weeklyEndDay: 5,
          });
          break;

        case '3':
          setIsoption1DivHidden(true);
          setIsoption0DivHiddencurrent(true);
          setIsDivHiddenrange(true);
          setIsDivHiddenhistory(false);
          setisChecked(false);
          setisDropchecked(false);
          sethistoryType(parseInt(option.key));
          settrendGranularity({
            ...vtrendGranularity,
            granularityType: 0,
            weeklyEndDay: 5,
          });
          break;

        default:
          break;
      }
    }
  }

  function handleChangegranularity(
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    option?: IChoiceGroupOption
  ): void {
    if (option) {
      switch (option.key) {
        case '0':
          setIsDivHiddendaily(false);
          setIsDivHiddenweek(true);
          break;

        case '1':
          setIsDivHiddenweek(false);
          setIsDivHiddendaily(true);
          settrendGranularity({
            ...vtrendGranularity,
            granularityType: parseInt(option.key),
            weeklyEndDay: 5,
          });
          break;

        case '2':
          setIsDivHiddenweek(true);
          setIsDivHiddendaily(false);
          settrendGranularity({
            ...vtrendGranularity,
            granularityType: parseInt(option.key),
            weeklyEndDay: 5,
          });
          break;
        default:
          break;
      }
    }
    //#endregion
  }

  const choiceGroupProps: IChoiceGroupProps & { onRenderField: any } = {
    options,
    onRenderField: renderField,
    label: '',
    defaultSelectedKey: vhistoryType,
    onChange: handleChange,
  };

  return (
    <>
      <div className='paddingRight30px'>
        <div className='height15'></div>
        <div className='ms-Grid-row'>
          <div className='text-align-left font-weight-bold'>
            {UATConstants.PlaceholdersAndTitles.History}
            <InfoIcon
              iconName='Info'
              tooltipText={UATConstants.PlaceholdersAndTitles.SelectValueStateFieldSubState}
            />
          </div>
          <div className='height10'></div>
          <div className='text-align-left'>{UATConstants.PlaceholdersAndTitles.DefineTime}</div>
          <div className='height5'></div>
          <div className='ms-Grid-col ms-lg12'>
            <ChoiceGroup
              {...choiceGroupProps}
              value={vhistoryType.toString()}
              defaultSelectedKey={vhistoryType.toString()}
            />
          </div>
        </div>
        <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-lg12'>
            <div className='text-align-left font-weight-bold'>
              {UATConstants.PlaceholdersAndTitles.Granularity}
              <InfoIcon
                iconName='Info'
                tooltipText={UATConstants.PlaceholdersAndTitles.SelectValueStateFieldSubState}
              />
            </div>
            <div className='height10'></div>
            <div className='text-align-left'>
              {UATConstants.PlaceholdersAndTitles.ShowDataDailyWeeklyMonthlyPeriod}
            </div>
            <div>
              <ChoiceGroup
                options={optionsGranularity}
                value={vtrendGranularity.granularityType?.toString()}
                defaultSelectedKey={vtrendGranularity.granularityType?.toString()}
                onChange={handleChangegranularity}
                disabled={isChecked}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
